import { IDiemQuyDoiActionTypes } from "../../action-types/category/IDiemQuyDoiActions";
import { IDiemQuyDoiReduce } from "../../reducer-model/category/IDiemQuyDoiReduce";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";


const iniState: IDiemQuyDoiReduce = {
    status: eReducerStatusBase.is_not_initialization,
    diemQuyDois: [],
}

export const diemQuyDoiReducer = (state: IDiemQuyDoiReduce = iniState, action: IDiemQuyDoiActionTypes): IDiemQuyDoiReduce => {
    switch (action.type) {
        case "DIEM_QUY_DOI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DIEM_QUY_DOI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                diemQuyDois: action.payload,
            };
        case "DIEM_QUY_DOI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DIEM_QUY_DOI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                diemQuyDoiEditing: action.payload,
            };
        case "DIEM_QUY_DOI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "DIEM_QUY_DOI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "DIEM_QUY_DOI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "DIEM_QUY_DOI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DIEM_QUY_DOI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DIEM_QUY_DOI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DIEM_QUY_DOI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}